/* eslint-disable @typescript-eslint/no-empty-function */
import { SerializedError } from '@reduxjs/toolkit';
import { FetchBaseQueryError } from '@reduxjs/toolkit/query/react';
import { Formik, Form, Field } from 'formik';
import { useTranslation } from 'react-i18next';
import * as yup from 'yup';

import i18n from '../../i18n/config';
import { Department } from '../services/apiGenerated';
import { PanelBase } from './components/PanelBase';
import { PanelContents } from './components/PanelContents';
import { PanelErrorFooter } from './components/PanelError';
import { PanelSubmit } from './components/PanelSubmit';

const validationSchema = yup.object().shape({
  departmentName: yup
    .string()
    .max(50, i18n.t('Naam mag minimaal 50 karakters bevatten'))
    .required(i18n.t('Dit veld is verplicht')),
  isActive: yup.boolean().required(),
});

interface PanelProps {
  isOpened: boolean;
  onClose: () => void;
  onSubmit: (dto: Partial<Department>) => void;
  title: string;
  description: string;
  department?: Department;
  isLoading: boolean;
  error?: SerializedError | FetchBaseQueryError | undefined;
}

export const DepartmentUpsertPanel: React.FC<PanelProps> = ({
  isOpened,
  onClose,
  onSubmit,
  title,
  description,
  department,
  isLoading,
  error,
}: PanelProps) => {
  const onSliderClosed = () => {
    onClose();
  };
  const { t } = useTranslation();
  return (
    <PanelBase isOpened={isOpened}>
      <Formik
        validationSchema={validationSchema}
        initialValues={{
          departmentName: department?.name ?? '',
          isActive: department?.isActive ?? true,
        }}
        onSubmit={(values) => {
          onSubmit({
            name: values.departmentName,
            isActive: values.isActive,
          });
        }}
      >
        {({
          errors,
          touched,
          // values, setValues
        }) => (
          <Form className='flex flex-col h-full bg-white divide-y divide-gray-200 shadow-xl'>
            <PanelContents title={title} description={description} onSliderClosed={onSliderClosed}>
              <div>
                <label htmlFor='project_name' className='block text-sm font-medium text-gray-900'>
                  {t('Naam afdeling')}
                </label>
                <div className='mt-1'>
                  <Field
                    autoComplete='false'
                    spellCheck={false}
                    type='text'
                    name='departmentName'
                    id='departmentName'
                    className={`block w-full border-gray-300 rounded-md shadow-sm sm:text-sm focus:ring-yellow-500 focus:border-yellow-500 ${
                      errors.departmentName && touched.departmentName ? 'border-red-500' : ''
                    }`}
                  />
                  {errors.departmentName && touched.departmentName && (
                    <span className='text-xs italic text-yellow-800'>{errors.departmentName}</span>
                  )}
                </div>
              </div>

              {/* <div>
                <div className='flex flex-row items-center'>
                  <Switch
                    checked={values.isActive}
                    onChange={(value) =>
                      setValues({
                        ...values,
                        isActive: value,
                      })
                    }
                    className={`${
                      values.isActive ? 'bg-yellow-600' : 'bg-gray-200'
                    } relative inline-flex items-center h-6 rounded-full w-11`}
                  >
                    <span
                      className={`${
                        values.isActive ? 'translate-x-6' : 'translate-x-1'
                      } inline-block w-4 h-4 transform bg-white rounded-full transition ease-in-out duration-200`}
                    />
                  </Switch>
                  <label htmlFor='isActive' className='ml-4 text-sm font-medium text-gray-900'>
                    {t('De afdeling en bijbehorende rapportages zijn actief')}
                  </label>
                </div>
              </div> */}
            </PanelContents>
            <PanelErrorFooter error={error} />
            <PanelSubmit isLoading={isLoading} onSliderClosed={onSliderClosed} />
          </Form>
        )}
      </Formik>
    </PanelBase>
  );
};
